<template>
	<b-container fluid class="mt-5 p-0">
		<b-card no-body>
			<b-card-header class="container-fluid">
				<b-row>
					<b-col xl="6" md="6">
						<div class="h3">Manage TopOff Plans</div>
					</b-col>
					<b-col xl="6" md="6" class="text-right">
						<b-button variant="success" size="sm" v-on:click="addNewTopOffPlanOpen"
							>Add New TopOff Plan</b-button
						>
					</b-col>
				</b-row>
			</b-card-header>
		</b-card>

		<div class="mt-4">
			<div class="text-center w-100">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>
			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col cols="12" xl="8" lg="7" md="7" sm="6">
						<b-form-group
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							class="mb-2 per-page-select"
						>
							<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
							<b-form-select
								id="per-page-select"
								class="diameter-report-select"
								v-model="perPage"
								:options="pageOptions"
								size="sm"
								v-on:input="changePageOption(perPage)"
							></b-form-select>
						</b-form-group>
					</b-col>

					<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="">
					<b-table
						striped
						hover
						:items="tableData"
						:fields="tableColumns"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:filter-included-fields="filterOn"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:sort-direction="sortDirection"
						head-variant="light"
						table-class="text-nowrap"
						class="data-management-table primary-table"
						sticky-header="true"
						thead-class="white"
						show-empty
						responsive
						small
						@sort-changed="headerColumnChanged"
						@filtered="onFiltered"
					>
						<template #cell(action)="row">
							<span class="nowrap">
								<i
									class="fas fa-pen-nib mr-3 cursor-pointer text-success"
									v-b-modal.top-off-plan
									v-on:click="editTopOffPlanInfo(row.item.id)"
								></i>
								<i
									class="fas fa-trash-alt cursor-pointer text-danger"
									v-on:click="deleteTopOffPlanInfo(row.item.id, row.item.name)"
								></i>
							</span>
						</template>
					</b-table>
				</div>
				<b-row class="mt-4">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>
		</div>

		<b-modal
			centered
			size="lg"
			id="top-off-plan"
			hide-footer
			:title="topOffPlanTitle"
			class="top-off-plan"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<CreateTopoffPlan></CreateTopoffPlan>
		</b-modal>
	</b-container>
</template>

<script>
import administratorService from "../../../../common/api-services/administrator-service";
import CreateTopoffPlan from "../../../Components/Add-TopOff-Plan";
import swal from "sweetalert2";
import handleResponse from "../../../../common/directive/handlResponse";
import pagination from '../../../../common/format/pagination'

export default {
	name: "TopOffPlans",
	components: {CreateTopoffPlan},
	data() {
		return {
			loadingStatus: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			tableColumns: [
				{key: "id", label: "ID", sortable: true, sortDirection: "desc"},
				{key: "name", label: "Name", sortable: true, sortDirection: "desc"},
				{key: "description", label: "Description", sortable: true, sortDirection: "desc"},
				{key: "price", label: "Price", sortable: true, sortDirection: "desc"},
				{key: "expires", label: "Expires", sortable: true, sortDirection: "desc"},
				{key: "amount", label: "Amount", sortable: true, sortDirection: "desc"},
				{key: "units", label: "Units", sortable: true, sortDirection: "desc"},
				{key: "type", label: "Type", sortable: true, sortDirection: "desc"},
				{key: "action", label: "", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			loadingNum: 1,
			paginationLoadingBar: true,
			topOffPlanTitle: "",
		};
	},
	mounted() {
		this.$root.$on("topOffPlanCall", res => {
			if (res) {
				this.getTopOffPlansFunc();
			}
		});

		this.getTotalRows();
		this.getTopOffPlansFunc();
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		paginationChanged(data) {
			if (data * 10 < this.totalRows) {
				this.fromPage = data * 10;
			} else {
				this.fromPage = this.totalRows;
			}
			this.currentPage = data;
			this.startPage = (this.currentPage - 1) * this.perPage + 1;
		},

		headerColumnChanged(e) {
			this.sortBy = e.sortBy;
			if (e.sortDesc === true) {
				this.sortDirection = "asc";
			} else {
				this.sortDirection = "desc";
			}
			this.getTopOffPlansFunc();
		},

		getTopOffPlansFunc() {
			this.loadingStatus = true;
			administratorService.getTopOffPlans().then(res => {
				this.loadingStatus = false;
				if (res && !res.includes('FAIL')) {
					this.tableData = res;
					this.totalRows = this.tableData.length;
					this.getTotalRows();
				}
			});
		},

		addNewTopOffPlanOpen() {
			this.topOffPlanTitle = "Create a Top Off Plan";
			this.$bvModal.show("top-off-plan");
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		editTopOffPlanInfo(id) {
			this.topOffPlanTitle = "Edit a Top Off Plan";
			this.tableData.map(item => {
				if (item.id === id) {
					let data = {item: item, status: true};
					setTimeout(() => {
						this.$root.$emit("editTopOffPlan", data);
					}, 400);
				}
			});
		},

		deleteTopOffPlanInfo(id, name) {
			swal.fire({
				title: `Top Off Plan Information`,
				text: `Delete selected Top Off Plan? ${name}`,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				cancelButtonText: "Cancel",
				customClass: {
					cancelButton: 'order-1 mr-3',
					confirmButton: 'btn btn-danger order-2',
				},
			}).then(result => {
				if (result.isConfirmed) {
					administratorService.deleteTopOffPlan(id).then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
						this.getTopOffPlansFunc();
					});
				}
			});
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>

<style scoped></style>
